export default __webpack_public_path__ + "images/207d7fad8d60b3d98905e34f196b7e28-boat.jpg";